// Kiosk API client — the kiosk surface authenticates with a Kiosk-Token
// (in-memory, per-session) instead of the Bearer/Firebase flow the main app
// uses, so it has its own fetch wrapper separate from src/lib/api.js.

// Kiosk fetch wrapper: attaches the Kiosk-Token header and throws on !ok.
export async function kioskApi(method, path, body, token) {
  const headers = { ...(body ? { 'Content-Type': 'application/json' } : {}) };
  if (token) headers['Authorization'] = `Kiosk-Token ${token}`;
  const res = await fetch(path, { method, headers, body: body ? JSON.stringify(body) : undefined });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Kiosk variant of openSignedDoc — same signed-URL flow using the kiosk token.
export async function openKioskSignedDoc(docId, filename, token) {
  try {
    const r = await kioskApi('POST', '/api/uploads/sign',
      { kind: 'doc', id: docId, filename }, token);
    if (!r?.signed_url) throw new Error('No signed URL returned');
    window.open(r.signed_url, '_blank', 'noopener,noreferrer');
  } catch (e) {
    alert('Could not open document: ' + (e?.message || 'unknown error'));
  }
}
